<form [formGroup]="form" class="space-y-3">
    <!-- Título -->
    <div>
        <label for="title" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Título<span class="text-red-500">*</span></label>
        <input
            id="title"
            type="text"
            pInputText
            formControlName="titulo"
            required
            placeholder="Titulo del evento"
            class="mt-1 block w-full rounded-lg shadow-sm focus:border-sky-500 focus:ring-2 focus:ring-sky-400 dark:text-gray-100"
        />
        <app-input-error [control]="form.get('titulo')"></app-input-error>
    </div>

    <!-- Descripción -->
    <div>
        <label for="description" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Descripción <span class="text-gray-500 dark:text-gray-300 text-md">(opcional)</span></label>
        <textarea
            id="description"
            pTextarea
            rows="1"
            formControlName="descripcion"
            placeholder="Ingrese una breve descripción del evento"
            class="mt-1 block w-full rounded-lg shadow-sm focus:border-sky-500 focus:ring-2 focus:ring-sky-400 dark:text-gray-100"
        ></textarea>
    </div>

    <!-- Fechas -->
    <div class="pb-2">
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Fechas <span class="text-red-500 dark:text-red-500 text-md">(La fecha final es opcional)</span></label>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <p-datepicker formControlName="comienza" dateFormat="dd/mm/yy" showIcon="true" [iconDisplay]="'input'" placeholder="Desde" [showTime]="!form.get('todoElDia')?.value" [showButtonBar]="true" class="w-full" [inputStyle]="{ width: '100%' }" appendTo="body" />

            <p-datepicker formControlName="fin" dateFormat="dd/mm/yy" showIcon="true" [iconDisplay]="'input'" placeholder="Hasta" [showTime]="!form.get('todoElDia')?.value" [showButtonBar]="true" class="w-full" [inputStyle]="{ width: '100%' }" appendTo="body" />
            <app-input-error [control]="form.get('fin')"></app-input-error>
        </div>

        <div class="flex items-center gap-2 mt-2">
            <p-checkbox formControlName="todoElDia" binary="true"></p-checkbox>
            <label class="text-sm text-gray-700 dark:text-gray-300">Todo el día</label>
        </div>
    </div>

    <!-- Color -->
    <div class="grid grid-cols-2 gap-4">
        <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 pb-2">Color</label>
            <p-select formControlName="color" [options]="colores" optionLabel="label" optionValue="value" class="w-full" appendTo="body">
                <ng-template let-color pTemplate="item">
                    <div class="flex items-center">
                        <div [style.background]="color.value" class="w-4 h-4 rounded-full mr-2 border border-gray-300"></div>
                        {{ color.label }}
                    </div>
                </ng-template>
            </p-select>
        </div>

        <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 pb-2">Recordatorio</label>
            <p-select class="w-full" [options]="tipoRecordatorio" formControlName="recordatorio" appendTo="body" (onChange)="onRecordatorioChange($event.value)" />
        </div>
    </div>

    <!-- Recordatorio -->
    <div>
        @if (mostrarPersonalizado) {
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 pb-2 pt-2">Personalizado</label>
            <p-datepicker formControlName="recordatorioPersonalizado" [showIcon]="true" [iconDisplay]="'input'" class="w-1/2" placeholder="Seleccionar fecha" dateFormat="dd/mm/yy" appendTo="body" hourFormat="24" [showButtonBar]="true" />
        }
    </div>

    <!-- Botones -->
    <div class="flex justify-end gap-3 pt-3 border-gray-200 dark:border-gray-700">
        <button type="button" pButton pRipple label="Guardar" class="calendar-modal-save-btn px-5 py-2 rounded-lg" (click)="guardar()"></button>
    </div>
</form>
